import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { TransparencyCell } from "./TransparencyCell";
import { AssetTableRowData } from "../types";

// // // //

export const TRANSPARENCY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    label: "Transparency",
    slug: AssetColumns.transparencyType,
    sortsOn: AssetColumns.transparencyType,
    type: ColumnTypes.string,
    width: 260,
    loginRequired: true,
    render: (item) => {
        if (item.isAsset) {
            return (
                <TransparencyCell
                    url={item.transparency_url}
                    type={item.transparency_type}
                    description={item.transparency_description}
                />
            );
        }

        return <Emdash />;
    },
};

export const TRANSPARENCY_COLUMN_RIGHT_JUSTIFY: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    ...TRANSPARENCY_COLUMN,
    render: (item) => {
        if (item.isAsset) {
            return (
                <TransparencyCell
                    url={item.transparency_url}
                    type={item.transparency_type}
                    description={item.transparency_description}
                    justify="right"
                />
            );
        }

        return <Emdash />;
    },
};
